/* Loose Gemstone Store v2 — interactive logic.
   Gated on #looseGemstoneStoreV2 so it only runs on pages using the new
   section-loose-gemstone-store-v2.liquid section, same gating pattern
   chatham-loosegemstone-func.js uses for page-loose-gems-store.

   Assumes `Applink` is already defined globally by the theme (it already is —
   the current live chatham-loosegemstone-func.js calls `Applink + 'GemstoneSizes/getTypes'`
   without ever defining Applink itself, so it must come from theme.liquid /
   another global include). If that assumption is wrong in your theme, define
   `var Applink = 'https://app.sebringcreative.com/';` before this file loads.

   No client-side pricing formula — every price shown comes from
   GemstoneStoreController.GetCatalog, which computes it from
   gemstone_pricing_tier server-side.

   Gemstone/Shape filter lists are hardcoded in the liquid markup (client's
   exact approved lists, 2026-07-05 feedback doc) rather than derived from
   the catalog data, since the client wants every category visible even at
   zero current inventory. This file only wires click handlers onto them. */
(function () {
    // ngrok-free serves a browser-warning page (ERR_NGROK_6024) unless the request
    // carries this header. Add it ONLY for ngrok URLs so it self-disables the moment
    // Applink points at the real domain. Guarded so it registers once even though
    // chatham-customer-request.js installs the same prefilter.
    if (window.jQuery && !window.__chathamNgrokPrefilter) {
        window.__chathamNgrokPrefilter = true;
        window.jQuery.ajaxPrefilter(function (options) {
            if (options.url && options.url.indexOf('ngrok') !== -1) {
                options.headers = options.headers || {};
                options.headers['ngrok-skip-browser-warning'] = 'true';
            }
        });
    }

    var root = document.getElementById('looseGemstoneStoreV2');
    if (!root) return;

    // LOCAL-TESTING image host override. When testing through an ngrok tunnel every
    // gem/shape/banner image would route through ngrok and quickly hit its rate/
    // bandwidth limits. Set `window.LGSv2_IMG_HOST` (e.g. 'http://localhost:PORT/'
    // or 'https://localhost:PORT/') — set by the section's "Image host override"
    // setting — to load images straight from local IIS Express instead. Blank in
    // production, so it falls back to Applink (the real app domain). Only images use
    // it; catalog/API calls still go through Applink.
    var IMG_HOST = (window.LGSv2_IMG_HOST ? String(window.LGSv2_IMG_HOST) : '') || Applink;
    if (IMG_HOST && IMG_HOST.charAt(IMG_HOST.length - 1) !== '/') IMG_HOST += '/';

    var IMG_BASE = IMG_HOST + 'UploadedFiles/';
    // Curated shape icons + per-gemstone banners live in the app's Content folder.
    var SHAPE_IMG_BASE = IMG_HOST + 'Content/GemstoneShapes/';
    var BANNER_BASE = IMG_HOST + 'Content/GemstoneBanners/';
    // filterGroup (data-fg) -> banner filename in Content/GemstoneBanners.
    var BANNER_MAP = {
        'alexandrite': 'Alexandrite Banner.jpg',
        'aqua-blue-spinel': 'Aqua Blue Spinel Banner.jpg',
        'blue-sapphire': 'Blue Sapphire Banner.jpg',
        'champagne-sapphire': 'Champagne Sapphire Banner.jpg',
        'chrysoberyl': 'Chrysoberyl Banner.jpg',
        'emerald': 'Emerald Banner.jpg',
        'opal': 'Opal Banner.jpg',
        'padparadscha': 'Padparadscha Banner.jpg',
        'paraiba-colored-spinel': 'Paraiba-Colored Spinel Banner.jpg',
        'pink-sapphire': 'Pink Sapphire Banner.jpg',
        'purple-sapphire': 'Purple Sapphire Banner.jpg',
        'ruby': 'Ruby Banner.jpg',
        'white-sapphire': 'White Sapphire Banner.jpg',
        'yellow-sapphire': 'Yellow Sapphire Banner.jpg'
    };
    var NO_RESULTS_TEXT = root.getAttribute('data-no-results') || 'No gemstones match your search. Try a different size, shape, or stone name — or clear your filters to see everything.';
    // Default shape filter disabled for now — catalog opens showing all shapes.
    // (Re-add 'ROUND' to `shapes` to bring back the round-only default.)
    var state = { filterGroup: 'all', shapes: [], shadeFilters: [], view: 'grid', cart: [], searchQuery: '', sortBy: 'best' };
    var CATALOG = [];
    var MATCH_FEE_TIERS = [];
    var PRICING_TIERS = [];
    var currentStep = 1;
    var activeGroupId = null;
    var invQtys = {};          // sizeId -> qty
    // Per-SIZE color matching (2026 mockup): each size carries its own choice
    // ('consistency' | 'color' | null). invColorMatch is keyed by sizeId.
    var invColorMatch = {};    // sizeId -> 'consistency' | 'color' | null
    var prodColorMatch = null; // "Apply to Entire Product" shortcut state

    function fmt(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    // (kept for compatibility; all imagery is now JPG.)
    function thumbSrc(img) { return IMG_BASE + String(img || '').replace(/\.(jpe?g|png|gif)$/i, '') + '.jpg'; }
    function circleSrc(img) { return IMG_BASE + 'roundfill/' + String(img || '').replace(/\.(jpe?g|png|gif)$/i, '') + '.jpg'; }

    // Ordered URLs to try for a stored image name: .jpg first (the whole catalog is
    // JPG now), then .jpeg, then .png/raw as legacy fallbacks — so we don't waste a
    // 404 on a non-existent PNG for every image. `circle` prepends the roundfill twins.
    function imgUrls(name, circle) {
        var base = String(name || '').replace(/\.(jpe?g|png|gif)$/i, '');
        var list = [];
        if (circle) list.push(IMG_BASE + 'roundfill/' + base + '.jpg', IMG_BASE + 'roundfill/' + base + '.png');
        list.push(IMG_BASE + base + '.jpg', IMG_BASE + base + '.jpeg', IMG_BASE + base + '.png', IMG_BASE + (name || ''));
        return list.filter(function (u, i) { return u && list.indexOf(u) === i; });
    }
    // onerror walker: step through the remaining candidates in data-fbs; when none
    // are left, fade the image and log its name so missing files are easy to spot
    // in the console ("[img-missing] <name>").
    window.LGSv2imgErr = function (el) {
        var fbs = (el.getAttribute('data-fbs') || '').split('|').filter(Boolean);
        if (fbs.length) { el.setAttribute('data-fbs', fbs.slice(1).join('|')); el.src = fbs[0]; }
        else { el.onerror = null; el.style.opacity = '.15'; if (el.getAttribute('data-imgname')) console.warn('[img-missing]', el.getAttribute('data-imgname')); }
    };
    // Build an <img> that cascades jpg -> jpeg -> png -> raw (and roundfill first if circle).
    function imgTag(name, alt, cls, circle) {
        var urls = imgUrls(name, circle);
        return '<img' + (cls ? ' class="' + cls + '"' : '') + ' src="' + urls[0] + '"' +
            ' data-fbs="' + urls.slice(1).join('|') + '" data-imgname="' + escapeHtml(name || '') + '"' +
            ' alt="' + escapeHtml(alt || '') + '" onerror="LGSv2imgErr(this)">';
    }
    function thumbImg(img, alt, cls) { return imgTag(img, alt, cls, false); }
    // Wire an existing <img> element (jQuery) to the same png/jpg cascade.
    function wireImg($img, name, circle) {
        var urls = imgUrls(name, circle);
        return $img.attr('src', urls[0]).attr('data-fbs', urls.slice(1).join('|'))
            .attr('data-imgname', name || '').attr('onerror', 'LGSv2imgErr(this)');
    }
    function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    // ---- SEARCH — "5.0mm round blue sapphire" style free text ----
    var searchDebounceTimer = null;
    $(document).on('input', '#catalogSearchInput', function () {
        var val = $(this).val();
        $('#searchClearBtn').toggleClass('hidden', !val);
        clearTimeout(searchDebounceTimer);
        searchDebounceTimer = setTimeout(function () {
            state.searchQuery = val.trim();
            // Typing a search clears the gemstone/shape/shade filters so results come
            // from the whole catalog, not just within the currently-selected filter.
            if (state.searchQuery) {
                state.filterGroup = 'all';
                state.shapes = [];
                state.shadeFilters = [];
                $('#gemTypeList .gtbtn').removeClass('active');
                $('#gemTypeList .gtbtn[data-fg="all"]').addClass('active');
                $('#shapeGrid .shbtn').removeClass('active');
            }
            renderCatalog();
        }, 200);
    });
    $(document).on('change', '#sortSel', function () { state.sortBy = $(this).val() || 'best'; renderCatalog(); });
    $(document).on('click', '#searchClearBtn', function () { clearSearch(); });
    $(document).on('click', '.empty-state-clear', function () { clearAll(); });

    // ---- LOAD CATALOG ----
    // ---- Browser-side catalog cache ----
    // The catalog is the same for everyone and changes rarely, so cache the whole
    // GetCatalog payload in the browser for a few minutes. On a reload / return
    // visit within that window we render instantly from cache and skip the network
    // round-trip entirely (the server already caches it too, but this also removes
    // the request itself). Prices/stock can be up to CATALOG_CACHE_TTL stale — the
    // server always recomputes price at order time, so this only affects display.
    var CATALOG_CACHE_KEY = 'lgsv2_catalog_v1';
    var CATALOG_CACHE_TTL = 5 * 60 * 1000; // 5 minutes
    // Append ?lgsv2_fresh=1 (or ?nocache=1 / ?clearcache=1) to the storefront URL to
    // wipe this browser's localStorage catalog cache and pull fresh from the server —
    // handy right after hitting /GemstoneStore/ClearCache so you don't wait out the TTL.
    function catalogCacheBypass() {
        try { return /[?&](lgsv2_fresh|nocache|clearcache)\b/i.test(window.location.search); }
        catch (e) { return false; }
    }
    function clearCatalogCache() {
        try { window.localStorage.removeItem(CATALOG_CACHE_KEY); } catch (e) { }
    }
    function readCatalogCache() {
        try {
            if (catalogCacheBypass()) { clearCatalogCache(); return null; }
            var raw = window.localStorage.getItem(CATALOG_CACHE_KEY);
            if (!raw) return null;
            var o = JSON.parse(raw);
            if (!o || !o.t || (new Date().getTime() - o.t) > CATALOG_CACHE_TTL) return null;
            return o.d;
        } catch (e) { return null; }
    }
    function writeCatalogCache(data) {
        try { window.localStorage.setItem(CATALOG_CACHE_KEY, JSON.stringify({ t: new Date().getTime(), d: data })); } catch (e) { /* private mode / quota — ignore */ }
    }
    function applyCatalog(data) {
        CATALOG = (data && data.groups) || [];
        MATCH_FEE_TIERS = (data && data.matchFeeTiers) || [];
        PRICING_TIERS = (data && data.pricingTiers) || [];
        wireFilterSidebar();
        renderCatalog();
        renderSidebar();
        // Rehydrate any in-progress order so previously-added items reappear in the
        // tray (this always hits the server — it's per-customer and must be fresh).
        hydratePendingCart();
    }

    function loadCatalog() {
        $('#catalogError').addClass('hidden');
        var cached = readCatalogCache();
        if (cached) { applyCatalog(cached); return; }   // instant — no network call
        $.ajax({
            url: Applink + 'GemstoneStore/GetCatalog',
            dataType: 'json',
            crossDomain: true,
            beforeSend: function () { $('#looseGemstoneStoreV2').addClass('show-loader'); },
            success: function (data) {
                $('#looseGemstoneStoreV2').removeClass('show-loader');
                writeCatalogCache(data);
                applyCatalog(data);
            },
            error: function (e) {
                $('#looseGemstoneStoreV2').removeClass('show-loader');
                console.error('GemstoneStore/GetCatalog failed', e);
                $('#catalogError').removeClass('hidden');
            }
        });
    }

    // Pull the customer's pending (not-yet-confirmed) order back into the client
    // cart on load. Saved lines store names (gem_type/gem_shape/gem_size), so we
    // match each back to a catalog group/size to rebuild a full cart line. Runs
    // after CATALOG is loaded (matching needs it). Merges into whatever is already
    // in the cart rather than clobbering, so it's safe if called after items exist.
    // Loose comparison helpers for rehydration. Saved order lines are matched back
    // to catalog rows by NAME, so any drift in spelling/spacing/case (or a size
    // re-normalisation like the stock import's "4.0"->"4", "10X8"->"10x8") would
    // otherwise break the exact match and silently drop the item from the tray.
    function nName(v) { return (v == null ? '' : String(v)).trim().toLowerCase().replace(/\s+/g, ' '); }
    function nSize(v) {
        var s = (v == null ? '' : String(v)).trim().toLowerCase().replace(/\s+/g, '').replace(/mm$/, '');
        if (/^[0-9.]+x[0-9.]+$/.test(s)) return s;            // dimension e.g. 10x8 == 10X8
        if (/^[0-9]*\.?[0-9]+$/.test(s)) return String(parseFloat(s)); // 4.0 == 4
        return s;
    }
    function hydratePendingCart() {
        $.ajax({
            url: Applink + 'GemstoneStore/GetPendingOrder',
            dataType: 'json',
            crossDomain: true,
            data: { customerId: parseInt($('#customer_id').val()) || 0 }
        }).done(function (res) {
            if (!res || !res.hasPending || !res.items || !res.items.length) return;
            if (res.orderId) $('#order_id').val(res.orderId);
            var added = 0;
            res.items.forEach(function (it) {
                var g = CATALOG.filter(function (x) {
                    return nName(x.displayName) === nName(it.gemType) && nName(x.shapeName) === nName(it.gemShape);
                })[0];
                if (!g) { console.warn('[hydrate] no catalog match for type/shape:', it.gemType, '/', it.gemShape); return; }
                var szObj = g.sizes.filter(function (s) { return nSize(s.size) === nSize(it.gemSize); })[0];
                if (!szObj) { console.warn('[hydrate] size not found:', it.gemSize, 'in', it.gemType, it.gemShape); return; }
                var qty = parseInt(it.qty) || 0;
                if (qty <= 0) return;
                // One line per size per product (id = groupId-sizeId). If the pending
                // order somehow has the same size twice, merge into the existing line.
                var lineId = g.groupId + '-' + szObj.sizeId;
                var existing = state.cart.filter(function (c) { return c.id === lineId; })[0];
                if (existing) { existing.qty += qty; }
                else {
                    state.cart.push({
                        id: lineId, groupId: g.groupId,
                        typeId: g.typeId, shapeId: g.shapeId, sizeId: szObj.sizeId,
                        baseStoneName: g.baseStoneName, shadeName: g.shadeName, shapeName: g.shapeName,
                        size: szObj.size, weight: szObj.weight, price: szObj.pricePerStone, qty: qty, img: g.img,
                        matchConsistency: !!it.matchConsistency, matchColor: !!it.matchColor
                    });
                }
                added++;
            });
            if (added) { renderSidebar(); renderCatalog(); }
        }).fail(function (xhr) {
            console.warn('[hydrate] GetPendingOrder request failed — status', xhr && xhr.status, '. Tray will not rehydrate.');
        });
    }
    $(document).on('click', '#catalogRetryBtn', function () { loadCatalog(); });

    // Append a filter chip for any gemstone family present in the catalog that
    // isn't already one of the fixed, client-approved buttons — so newly added
    // gemstone types (e.g. a test stone) become filterable automatically instead
    // of only appearing under "All". The approved buttons are never removed.
    function appendDynamicGemTypes() {
        var $list = $('#gemTypeList');
        var have = {};
        $list.find('.gtbtn[data-fg]').each(function () { have[$(this).data('fg').toString()] = true; });
        var seen = {};
        CATALOG.forEach(function (g) {
            var fg = (g.filterGroup || '').toString();
            if (!fg || fg === 'all' || have[fg] || seen[fg]) return;
            seen[fg] = true;
            var label = g.baseStoneName || g.displayName || fg;
            $('<button class="gtbtn"></button>').attr('data-fg', fg).text(label).appendTo($list);
        });
    }

    // Append a shape chip for any shape present in the catalog that isn't already
    // one of the fixed standard-shape buttons (matched by canonical name, so
    // "Antique Cushion" still maps to the CUSHION button). Custom/test shapes get a
    // plain text chip (no curated icon). Approved shapes are never removed.
    function appendDynamicShapes() {
        var $grid = $('#shapeGrid');
        var have = {};
        $grid.find('.shbtn[data-shape]').each(function () { have[canonShape($(this).data('shape').toString())] = true; });
        var seen = {};
        CATALOG.forEach(function (g) {
            var sh = (g.shapeName || '').toString();
            var c = canonShape(sh);
            if (!c || have[c] || seen[c]) return;
            seen[c] = true;
            // No .sh-svg element -> injectShapeIcons skips it, leaving a text-only chip.
            $('<button class="shbtn shbtn-dynamic"></button>').attr('data-shape', sh).text(sh).appendTo($grid);
        });
    }

    // ---- FILTER SIDEBAR (fixed approved list + any dynamic catalog types) ----
    function wireFilterSidebar() {
        appendDynamicGemTypes();
        // Delegated so dynamically-appended chips get the handler too.
        $('#gemTypeList').off('click.gt').on('click.gt', '.gtbtn', function () {
            state.filterGroup = $(this).data('fg').toString();
            // Switching (or re-clicking) a gemstone starts a fresh selection — drop any
            // shade "Options" filter from the previous stone, otherwise it keeps filtering
            // the new stone by a shade that doesn't belong to it and shows wrong results.
            state.shadeFilters = [];
            $('#gemTypeList .gtbtn').removeClass('active');
            $(this).addClass('active');
            renderCatalog();
        });
        appendDynamicShapes();
        // Delegated so dynamically-appended shape chips get the handler too.
        $('#shapeGrid').off('click.sh').on('click.sh', '.shbtn', function () {
            var sh = $(this).data('shape').toString();
            var i = state.shapes.indexOf(sh);
            if (i >= 0) { state.shapes.splice(i, 1); $(this).removeClass('active'); }
            else { state.shapes.push(sh); $(this).addClass('active'); }
            renderCatalog();
        });
        injectGemTypeIcons();
        injectShapeIcons();
        // Reflect the default ROUND shape filter (state.shapes) in the button UI.
        state.shapes.forEach(function (sh) {
            $('#shapeGrid .shbtn[data-shape="' + sh + '"]').addClass('active');
        });
    }

    // Replace the inline shape SVGs with the curated photos in Content/GemstoneShapes.
    // Filename = title-cased data-shape (e.g. "SQUARE EMERALD CUT" -> "Square Emerald Cut.png").
    function injectShapeIcons() {
        $('#shapeGrid .shbtn').each(function () {
            var sh = $(this).data('shape');
            if (sh == null) return;
            var name = String(sh).toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
            var url = SHAPE_IMG_BASE + encodeURIComponent(name + '.png');
            $(this).find('.sh-svg').replaceWith(
                $('<img class="sh-svg">').attr('src', url).attr('alt', String(sh))
            );
        });
    }

    // Banner swaps to the selected gemstone's image from Content/GemstoneBanners;
    // falls back to the section-setting default for "All"/unmapped; hidden if neither.
    function renderBanner() {
        var $wrap = $('#catalogBanner');
        if (!$wrap.length) return;
        var file = BANNER_MAP[state.filterGroup];
        var src = file ? BANNER_BASE + encodeURIComponent(file) : ($wrap.data('default-banner') || '');
        if (src) {
            $('#catalogBannerImg').attr('src', src);
            $wrap.removeClass('hidden');
        } else {
            $wrap.addClass('hidden');
        }
    }

    // Curated filter-icon photos (not pulled from live catalog product images).
    var FILTER_ICONS = {
        'alexandrite': 'filter-alexandrite.png',
        'aqua-blue-spinel': 'filter-aqua-blue-spinel.png',
        'blue-sapphire': 'filter-blue-sapphire.png',
        'champagne-sapphire': 'filter-champagne-sapphire.png',
        'chrysoberyl': 'filter-chrysoberyl.png',
        'emerald': 'filter-emerald.png',
        'opal': 'filter-opal.png',
        'padparadscha': 'filter-padparadscha.png',
        'paraiba-colored-spinel': 'filter-paraiba-colored-spinel.png',
        'pink-sapphire': 'filter-pink-sapphire.png',
        'ruby': 'filter-ruby.png',
        'white-sapphire': 'filter-white-sapphire.png',
        'yellow-sapphire': 'filter-yellow-sapphire.png'
    };

    // Gem-type filter icons use each family's ROUND-shape photo (per client).
    // Falls back to any shape's photo, then the curated filter icon.
    function injectGemTypeIcons() {
        $('#gemTypeList .gtbtn[data-fg]').each(function () {
            var fg = $(this).data('fg').toString();
            if (fg === 'all' || $(this).find('.gem-icon').length) return;
            var groups = CATALOG.filter(function (g) { return g.filterGroup === fg; });
            // Prefer a shape that actually HAS an image (round first) — picking groups[0]
            // blindly left the icon blank when the first shape had no image row (e.g.
            // Purple Sapphire, where ROUND has an image but an earlier shape may not).
            var withImg = groups.filter(function (g) { return g.img; });
            var round = withImg.filter(function (g) { return /round/i.test(g.shapeName || ''); })[0];
            var sample = round || withImg[0] || groups[0];
            // roundfill twin first (fills the circle), then png/jpg/raw via the shared
            // cascade; grey chip only if truly nothing loads.
            var urls;
            if (sample && sample.img) urls = imgUrls(sample.img, true);
            else if (FILTER_ICONS[fg]) urls = [IMG_BASE + 'filter-imgs/' + FILTER_ICONS[fg]];
            else return;
            $('<img class="gem-icon">').attr('alt', fg)
                .attr('src', urls[0]).attr('data-fbs', urls.slice(1).join('|'))
                .attr('data-imgname', (sample && sample.img) || fg)
                .attr('onerror', 'LGSv2imgErr(this)')
                .prependTo(this);
        });
    }

    // Mobile: open/close the filter sidebar as a left off-canvas drawer.
    function toggleFilters(open) {
        var show = (open === undefined) ? !$('#filterSidebar').hasClass('open') : !!open;
        $('#filterSidebar').toggleClass('open', show);
        $('#filterOverlay').toggleClass('open', show);
        $('body').css('overflow', show ? 'hidden' : '');
    }

    // Mobile-only: the Order Tray is a right off-canvas drawer (hidden inline on
    // phones). The header tray button opens it; overlay/close button close it.
    function toggleTray(open) {
        var show = (open === undefined) ? !$('.order-sidebar').hasClass('open') : !!open;
        $('.order-sidebar').toggleClass('open', show);
        $('#trayOverlay').toggleClass('open', show);
        $('body').css('overflow', show ? 'hidden' : '');
    }

    function clearGemType() {
        state.filterGroup = 'all';
        // renderStoneInfoBox() returns early for the "all" view, so it never reaches
        // the branch that nulls shadeFilter — clear it here or a stale shade would
        // keep filtering the "All" grid.
        state.shadeFilters = [];
        $('#gemTypeList .gtbtn').removeClass('active');
        $('#gemTypeList .gtbtn[data-fg="all"]').addClass('active');
        renderCatalog();
    }
    function clearShape() {
        state.shapes = [];
        $('#shapeGrid .shbtn').removeClass('active');
        renderCatalog();
    }
    function clearSearch() {
        state.searchQuery = '';
        $('#catalogSearchInput').val('');
        $('#searchClearBtn').addClass('hidden');
        renderCatalog();
    }
    function clearAll() { clearGemType(); clearShape(); clearSearch(); }
    function removeShape(s) {
        state.shapes = state.shapes.filter(function (x) { return x !== s; });
        $('#shapeGrid .shbtn').each(function () { if ($(this).data('shape').toString() === s) $(this).removeClass('active'); });
        renderCatalog();
    }

    // Free-text search — e.g. "5.0mm round blue sapphire" — matches against
    // stone name, shade, shape, and any of the group's own sizes. Every token
    // must match SOMETHING (AND across tokens) so multi-word queries narrow
    // down rather than broaden. Composes with the sidebar filters (AND), same
    // as the shade-swatch filter already does.
    function searchMatches(g, tokens) {
        var haystack = (g.baseStoneName + ' ' + (g.shadeName || '') + ' ' + g.shapeName + ' ' + g.filterGroup).toLowerCase();
        return tokens.every(function (t) {
            if (haystack.indexOf(t) !== -1) return true;
            var numeric = t.replace(/(mm|cts?)$/, '');
            if (numeric && haystack.indexOf(numeric) !== -1) return true;
            return g.sizes.some(function (sz) { return sz.size.toLowerCase().indexOf(numeric || t) !== -1; });
        });
    }
    // Shape filter buttons read CUSHION / SQUARE CUSHION, but the catalog stores
    // these families as "Antique Cushion" / "Square Antique Cushion" (client's
    // style-number naming). Canonicalize by dropping the "ANTIQUE" token so the
    // filter matches the data. Harmless for every other shape.
    function canonShape(s) {
        return String(s || '').toUpperCase().replace(/\bANTIQUE\b/g, '').replace(/\s+/g, ' ').trim();
    }
    function shapeSelected(g) {
        if (!state.shapes.length) return true;
        var cg = canonShape(g.shapeName);
        return state.shapes.some(function (sh) { return canonShape(sh) === cg; });
    }
    function getFiltered() {
        var tokens = state.searchQuery ? state.searchQuery.toLowerCase().split(/\s+/).filter(Boolean) : [];
        return CATALOG.filter(function (g) {
            if (state.filterGroup !== 'all' && g.filterGroup !== state.filterGroup) return false;
            if (!shapeSelected(g)) return false;
            if (tokens.length && !searchMatches(g, tokens)) return false;
            return true;
        });
    }

    function groupInCart(gid) { return state.cart.some(function (c) { return c.groupId === gid; }); }

    // ---- STONE INFO BOX: shade swatches + wholesale pricing table for the selected filter ----
    function tierWeightLabel(t) {
        return t.max_weight >= 900 ? t.min_weight.toFixed(2) + '+ cts' : t.min_weight.toFixed(2) + ' - ' + t.max_weight.toFixed(2) + ' cts';
    }
    function tierPriceLabel(t) {
        if (t.flat_price != null) return fmt(t.flat_price) + '/stone';
        if (t.price_per_carat != null) return fmt(t.price_per_carat) + '/ct';
        return '—';
    }

    function renderStoneInfoBox() {
        var box = $('#stoneInfoBox');
        if (state.filterGroup === 'all') { box.addClass('hidden'); return; }
        var groupsInFilter = CATALOG.filter(function (g) { return g.filterGroup === state.filterGroup; });
        if (!groupsInFilter.length) { box.addClass('hidden'); return; }
        var sample = groupsInFilter[0];

        // WHOLESALE PRICING table — same tiers admin sets in gemstone_pricing_tier,
        // keyed off this stone family's pricing_category.
        var tiers = PRICING_TIERS.filter(function (t) { return t.pricing_category === sample.pricingCategory; })
            .sort(function (a, b) { return a.min_weight - b.min_weight; });
        $('#pricingTierTable').html(tiers.map(function (t) {
            return '<tr><td>' + tierWeightLabel(t) + '</td><td>' + tierPriceLabel(t) + '</td></tr>';
        }).join(''));
        $('#stoneInfoPricing').toggleClass('hidden', tiers.length === 0);

        // Shade OPTIONS — one circular swatch (using that shade's own catalog photo)
        // per distinct shade within this stone family.
        // Pick each shade's ROUND-shape group for the swatch image (fall back to any
        // shape only if that shade has no round) so Options always shows a round gem.
        var shades = {};
        groupsInFilter.forEach(function (g) {
            if (!g.shadeName) return;
            var isRound = /round/i.test(g.shapeName || '');
            if (!shades[g.shadeName] || isRound) shades[g.shadeName] = g;
        });
        var shadeNames = Object.keys(shades);
        if (shadeNames.length) {
            state.shadeFilters = state.shadeFilters || [];
            $('#shadeSwatchRow').html(shadeNames.map(function (s) {
                var active = state.shadeFilters.indexOf(s) >= 0 ? ' active' : '';
                // Filled round image (roundfill twin) so Options swatches match the filter icons.
                return '<button class="shade-swatch' + active + '" data-shade="' + s + '">' +
                    imgTag(shades[s].img, s, 'shade-swatch-img', true) + s + '</button>';
            }).join(''));
            // Multi-select: clicking toggles each shade in/out of the active set.
            $('#shadeSwatchRow .shade-swatch').on('click', function () {
                var s = $(this).data('shade').toString();
                var i = state.shadeFilters.indexOf(s);
                if (i >= 0) state.shadeFilters.splice(i, 1); else state.shadeFilters.push(s);
                renderCatalog();
            });
            $('#stoneInfoShades').removeClass('hidden');
        } else {
            $('#stoneInfoShades').addClass('hidden');
            state.shadeFilters = [];
        }
        // Limited-production / availability disclaimer. Champagne Sapphire's "True"
        // shade can't be guaranteed, so surface that whenever this family is shown.
        var disc = '';
        if (state.filterGroup === 'champagne-sapphire') {
            disc = 'Due to the nature of growth, we cannot guarantee availability of “true” champagne sapphire. This color designation is limited in production.';
        }
        var $disc = $('#stoneInfoDisclaimer');
        if (disc) { $disc.text(disc).removeClass('hidden'); } else { $disc.text('').addClass('hidden'); }

        // Don't render an empty box below the banner — only show it when there's
        // actually a wholesale pricing table, shade options, and/or a disclaimer.
        box.toggleClass('hidden', tiers.length === 0 && shadeNames.length === 0 && !disc);
    }

    // ---- CATALOG RENDER ----
    // Base (smallest-size) per-stone price used as the sort key for price sorts.
    function groupBasePrice(g) {
        if (!g.sizes || !g.sizes.length) return 0;
        return g.sizes.reduce(function (m, sz) {
            var p = sz.pricePerStone || 0;
            return (m === null || p < m) ? p : m;
        }, null) || 0;
    }
    function sortGroups(groups) {
        var arr = groups.slice();
        switch (state.sortBy) {
            case 'az':
                arr.sort(function (a, b) { return a.baseStoneName.localeCompare(b.baseStoneName) || (a.shadeName || '').localeCompare(b.shadeName || ''); });
                break;
            case 'plh':
                arr.sort(function (a, b) { return groupBasePrice(a) - groupBasePrice(b); });
                break;
            case 'phl':
                arr.sort(function (a, b) { return groupBasePrice(b) - groupBasePrice(a); });
                break;
            default: // 'best' — BESTSELLER-badged products first, otherwise catalog order
                arr.sort(function (a, b) {
                    return (isBestseller(b) ? 1 : 0) - (isBestseller(a) ? 1 : 0);
                });
        }
        return arr;
    }
    function renderCatalog() {
        renderBanner();
        renderStoneInfoBox();
        var sf = state.shadeFilters || [];
        var groups = getFiltered().filter(function (g) {
            return !sf.length || sf.indexOf(g.shadeName) >= 0;
        });
        groups = sortGroups(groups);
        $('#resultCount').text(groups.length);
        renderActiveTags();
        if (state.view === 'grid') renderGrid(groups); else renderListView(groups);
    }

    function renderActiveTags() {
        var html = '';
        if (state.searchQuery) {
            html += '<span class="atag atag-outline">Search: "' + escapeHtml(state.searchQuery) + '"<button data-clear-search>&times;</button></span>';
        }
        if (state.filterGroup !== 'all') {
            html += '<span class="atag">' + $('#gemTypeList .gtbtn.active').text() + '<button data-clear-gemtype>&times;</button></span>';
        }
        state.shapes.forEach(function (s) {
            html += '<span class="atag">' + s + '<button data-remove-shape="' + s + '">&times;</button></span>';
        });
        if (html) html += '<button class="clr-all" data-clear-all>Clear All</button>';
        $('#activeTags').html(html);
        $('#activeTags [data-clear-search]').on('click', clearSearch);
        $('#activeTags [data-clear-gemtype]').on('click', clearGemType);
        $('#activeTags [data-clear-all]').on('click', clearAll);
        $('#activeTags [data-remove-shape]').on('click', function () { removeShape($(this).data('remove-shape')); });
    }

    // Friendly no-results gesture — icon + the section-configurable message +
    // a one-click "Clear filters" escape hatch (only when filters are active).
    function noResultsHtml() {
        var hasFilters = state.searchQuery || state.filterGroup !== 'all' || state.shapes.length || (state.shadeFilters || []).length;
        var tips = '<div class="search-tips"><div class="search-tips-ttl">Search tips</div><ul>' +
            '<li>Type dimensions with <strong>no spaces</strong> — e.g. <strong>12x10mm</strong>, not &ldquo;12x10 mm&rdquo;.</li>' +
            '<li>Combine size, shape and stone — e.g. <strong>5mm round blue sapphire</strong>.</li>' +
            '<li>Word order doesn&rsquo;t matter and it&rsquo;s not case-sensitive.</li>' +
            '<li>Try fewer or shorter words if nothing shows.</li>' +
            '</ul></div>';
        return '<div class="empty-state">' +
            '<div class="empty-state-icon"><svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><circle cx="21" cy="21" r="14"/><line x1="31" y1="31" x2="42" y2="42"/></svg></div>' +
            '<h3>No results found</h3>' +
            '<p>' + escapeHtml(NO_RESULTS_TEXT) + '</p>' +
            tips +
            (hasFilters ? '<button class="empty-state-clear" data-clear-all>Clear filters</button>' : '') +
            '</div>';
    }

    // Corner flag on tiles — fully DB-driven and product-level: one badge per
    // Type+Shape (shapes_type_img_master.badge), set on the "Edit Shape Images"
    // admin screen or via the bulk import's Badge column, surfaced as g.badge.
    // Known words are themed; any other text is a neutral pill.
    function badgeClass(label) {
        var t = (label || '').trim().toLowerCase();
        if (t === 'new') return 'flag-new';
        if (t === 'limited') return 'flag-limited';
        if (t === 'bestseller' || t === 'best seller') return 'flag-best';
        return 'flag-custom';
    }
    function isBestseller(g) { return /^best\s?seller$/i.test((g.badge || '').trim()); }
    function flagHtml(g) {
        var label = (g.badge || '').trim();
        if (!label) return '';
        return '<span class="gem-flag ' + badgeClass(label) + '">' + escapeHtml(label) + '</span>';
    }

    function renderGrid(groups) {
        var el = $('#gemGrid');
        if (!groups.length) { el.html(noResultsHtml()); return; }
        el.html(groups.map(function (g) {
            var inCart = groupInCart(g.groupId);
            // Size count + price hidden per client (many sizes OOS; price implied the
            // smallest size and was misleading). shadeLine keeps shape + shade only.
            var shadeLine = g.shadeName ? g.shapeName + ' &middot; ' + g.shadeName : g.shapeName;
            return '<div class="gem-card' + (inCart ? ' in-cart' : '') + '" data-group="' + g.groupId + '">' +
                '<div class="gem-img-wrap">' + flagHtml(g) + imgTag(g.img, g.displayName) + '</div>' +
                '<div class="gem-info"><div class="gem-name">' + g.baseStoneName + '</div><div class="gem-sub">' + shadeLine + '</div></div>' +
                '<div class="gem-card-foot"><div class="in-cart-badge">&#10003; In Order</div>' +
                '<button class="btn-quick-add">Select Sizes</button></div></div>';
        }).join(''));
        // Whole card is clickable — opens the drawer for this product (pre-filled
        // if it's already in the cart, blank otherwise).
        el.find('.gem-card').on('click', function () { openInvPanel($(this).data('group').toString()); });
    }

    function renderListView(groups) {
        var el = $('#gemListView');
        if (!groups.length) { el.html(noResultsHtml()); return; }
        el.html(groups.map(function (g) {
            var inCart = groupInCart(g.groupId);
            // Size count + price hidden per client (see renderGrid note).
            return '<div class="gl-row' + (inCart ? ' in-cart' : '') + '" data-group="' + g.groupId + '">' +
                '<div class="gl-thumb">' + flagHtml(g) + thumbImg(g.img, g.displayName) + '</div>' +
                '<div><div class="gl-name">' + g.baseStoneName + (g.shadeName ? ' &mdash; ' + g.shadeName : '') + '</div><div class="gl-sub">' + g.shapeName + '</div></div>' +
                '<div class="gl-cell">' + (g.sizes[0] ? g.sizes[0].size : '') + '&ndash;' + (g.sizes[g.sizes.length - 1] ? g.sizes[g.sizes.length - 1].size : '') + ' mm</div>' +
                '<div class="gl-cell"><button class="btn-quick-add" style="font-size:9px;padding:5px 10px;">Select Sizes</button></div></div>';
        }).join(''));
        el.find('.gl-row').on('click', function () { openInvPanel($(this).data('group').toString()); });
    }

    function setView(v) {
        state.view = v;
        $('#gemGrid').css('display', v === 'grid' ? '' : 'none');
        $('#gemListView').toggleClass('active', v === 'list');
        $('#gridViewBtn').toggleClass('active', v === 'grid');
        $('#listViewBtn').toggleClass('active', v === 'list');
        renderCatalog();
    }

    // ---- COLOR MATCHING FEE (per size — each size's own qty sets its tier) ----
    // 2026-08 rule (mirrors CustomerOrderController.color_match_cost exactly):
    //   1 stone   -> free (nothing to match against)
    //   2 stones  -> $10 flat          (color-match-2)
    //   3-15      -> qty x $3.50        (color-match-3-to-15)  e.g. 3 = $10.50, 5 = $17.50, 15 = $52.50
    //   16+       -> Call for Quote (no auto price; Care Team quotes offline)
    function matchTier(key) {
        var t = MATCH_FEE_TIERS.filter(function (x) { return x.additional_key === key; })[0];
        return t ? t.additional_cost : 0;
    }
    function computeMatchFee(qty) {
        if (qty <= 1) return 0;                                        // single stone = free
        if (qty === 2) return matchTier('color-match-2');             // 2 stones = $10 flat
        if (qty <= 15) return qty * matchTier('color-match-3-to-15'); // 3-15 = qty x $3.50 (3 = $10.50)
        return 0;                                                     // 16+ = Call for Quote
    }

    // Rate-card legend inside the drawer's fee-warning box, sourced from the same
    // additional_items rows CreateOrderItems prices from (never hardcoded), plus a
    // constant 15+ "Call for Quote" line (that tier is handled offline).
    function renderMatchFeeLegend() {
        // 2026 rate card is a single flat rate ($3.50/stone up to 15) held in the
        // 'color-match-3-to-15' row; 'color-match-2' just carries the equivalent
        // flat fee for a 2-stone order and isn't shown as a separate line.
        // Explain the two match types up top, then the fee schedule below.
        var lines = [
            'Match Consistency (no charge): a quick visual check to ensure the stones appear consistent and uniform.',
            'Match Color (charges apply): a thorough inspection of each stone for the best color and size match.'
        ];
        lines.push('Match Color charges: ' + fmt(matchTier('color-match-2')) + ' flat for 2 stones; ' + fmt(matchTier('color-match-3-to-15')) + ' per stone for 3-15 stones (e.g. 3 stones = ' + fmt(3 * matchTier('color-match-3-to-15')) + ').');
        lines.push('For 16 or more stones — call for quote.');
        // This whole card lives in the info-icon tooltip on the "Apply to All" widget.
        $('#cmFeeTip').attr('data-tip', lines.join('\n'));
    }

    // ---- QTY DRAWER (per-size color matching) ----
    // One mode: opening from a catalog card OR a tray card loads the whole
    // product (all its sizes). Existing cart lines pre-fill qty + per-size color
    // match; Save (addInvToCart) REPLACES that product's lines with what's shown.
    function openInvPanel(gid) {
        var g = CATALOG.filter(function (x) { return x.groupId === gid; })[0];
        if (!g) return;
        activeGroupId = gid;
        invQtys = {}; invColorMatch = {}; prodColorMatch = null;
        var existing = state.cart.filter(function (c) { return c.groupId === gid; });
        existing.forEach(function (c) {
            invQtys[c.sizeId] = (invQtys[c.sizeId] || 0) + c.qty;
            invColorMatch[c.sizeId] = c.matchColor ? 'color' : (c.matchConsistency ? 'consistency' : null);
        });
        $('#qtyDrawerTitle').text(g.baseStoneName + (g.shadeName ? ' — ' + g.shadeName : ''));
        $('#qtyDrawerSub').text(g.shapeName);
        // Use the FULL original image (not the circle-cropped roundfill twin) so
        // square shapes aren't clipped — shown "contain" on white in the header.
        wireImg($('#qtyDrawerImg').off('error'), g.img, false);
        $('#invPanelAddBtn').text(existing.length ? 'Update Order →' : 'Add to Order →');
        renderSizeCards(g);
        // On mobile the Order Tray is itself a drawer; close it so the edit drawer
        // (opened by tapping a tray product) isn't hidden behind it.
        toggleTray(false);
        $('#qtyDrawerOverlay, #qtyDrawer').addClass('open');
        $('body').css('overflow', 'hidden');
    }
    function closeInvPanel() {
        $('#qtyDrawerOverlay, #qtyDrawer').removeClass('open');
        $('body').css('overflow', '');
        activeGroupId = null; invQtys = {}; invColorMatch = {}; prodColorMatch = null;
    }

    // Build the size cards. Called on open + on stepper/CM/apply changes. Qty
    // TYPING uses a targeted update (the input handler below) so focus is kept.
    // Per-row additional-charge label (Match Color only).
    function rowFeeHtml(sizeId) {
        var qty = invQtys[sizeId] || 0;
        if (invColorMatch[sizeId] !== 'color' || qty <= 0) return '';
        if (qty > 15) return 'Call for quote';
        var f = computeMatchFee(qty);
        return f > 0 ? '+' + fmt(f) : '';
    }
    function renderSizeCards(g) {
        // Compact table with −/+ qty steppers and the Color Matching dropdown as a
        // column; out-of-stock sizes are hidden entirely (per client).
        var sizes = g.sizes.filter(function (sz) { return sz.inStock; });
        var rows = sizes.map(function (sz) {
            var qty = invQtys[sz.sizeId] || 0;
            var cm = invColorMatch[sz.sizeId] || '';
            return '<tr class="inv-row' + (qty > 0 ? ' has-qty' : '') + '" data-size="' + sz.sizeId + '">' +
                '<td class="iv-size">' + sz.size + ' mm<span class="iv-ct">' + (sz.weight || 0).toFixed(2) + ' ct</span></td>' +
                '<td class="iv-est">' + fmt(sz.pricePerStone) + '</td>' +
                '<td class="iv-qty"><div class="iv-stepper">' +
                '<button type="button" class="iv-step" data-qty-step="' + sz.sizeId + ':-1">&minus;</button>' +
                '<input class="iv-qty-input" type="number" min="0" value="' + qty + '" data-qty-input="' + sz.sizeId + '">' +
                '<button type="button" class="iv-step" data-qty-step="' + sz.sizeId + ':1">+</button>' +
                '</div></td>' +
                '<td class="iv-cm"><select class="iv-cm-select" data-cm="' + sz.sizeId + '"' + (qty > 0 ? '' : ' disabled') + '>' +
                '<option value="">None</option>' +
                '<option value="consistency"' + (cm === 'consistency' ? ' selected' : '') + '>Match Consistency</option>' +
                '<option value="color"' + (cm === 'color' ? ' selected' : '') + '>Match Color (charges apply)</option>' +
                '</select><div class="iv-cm-fee">' + rowFeeHtml(sz.sizeId) + '</div></td></tr>';
        }).join('');
        var body = rows || '<tr><td colspan="4" class="iv-empty">No in-stock sizes available.</td></tr>';
        $('#sizeCardsWrap').html(
            '<table class="inv-table-compact"><thead><tr>' +
            '<th class="iv-th-size">Size/Weight</th><th class="iv-th-est">Est.</th><th class="iv-th-qty">Qty</th>' +
            '<th class="cm-head">Color Matching' +
            '<span class="cm-head-i" tabindex="0" data-tip="Match Consistency (no charge): a quick visual check to ensure the stones appear consistent and uniform.&#10;Match Color (charges apply): a thorough inspection of each stone for the best color and size match.&#10;Match Color charges: $10 flat for 2 stones; $3.50 per stone for 3-15 (e.g. 3 = $10.50).&#10;For 16+ stones — call for quote.">i</span>' +
            '</th>' +
            '</tr></thead><tbody>' + body + '</tbody></table>'
        );
        renderMatchFeeLegend();
        updateInvTotals(g);
        renderProdCmUI();
    }

    // Live totals — text/visibility only, never rebuilds the qty inputs.
    function updateInvTotals(g) {
        var stones = 0, fee = 0, totalQty = 0;
        g.sizes.forEach(function (sz) {
            var q = invQtys[sz.sizeId] || 0;
            if (q > 0) {
                stones += sz.pricePerStone * q; totalQty += q;
                if (invColorMatch[sz.sizeId] === 'color') fee += computeMatchFee(q);
            }
        });
        var total = stones + fee;
        $('#scTotalRow').css('display', totalQty > 0 ? 'flex' : 'none');
        $('#scTotalQty').text(totalQty + ' stone' + (totalQty !== 1 ? 's' : ''));
        $('#prodCmSection').css('display', totalQty > 0 ? 'block' : 'none');
        // Single-line total: stones + additional = final (additional part only when >0).
        if (total <= 0) {
            $('#invPanelEst').text('—');
        } else if (fee > 0) {
            $('#invPanelEst').html(fmt(stones) + ' <span class="est-add">+ ' + fmt(fee) + '</span> = <strong>' + fmt(total) + '</strong>');
        } else {
            $('#invPanelEst').html('<strong>' + fmt(total) + '</strong>');
        }
        $('#invPanelAddBtn').prop('disabled', totalQty === 0);
    }

    // "Apply to Entire Product" — set every size that has a qty to one choice.
    function setProdColorMatch(val) {
        prodColorMatch = val;
        Object.keys(invQtys).forEach(function (sizeId) {
            if ((invQtys[sizeId] || 0) <= 0) return;
            if (val === null) delete invColorMatch[sizeId]; else invColorMatch[sizeId] = val;
        });
        var g = CATALOG.filter(function (x) { return x.groupId === activeGroupId; })[0];
        if (g) renderSizeCards(g);
    }
    function renderProdCmUI() {
        var vals = Object.keys(invColorMatch).filter(function (k) { return (invQtys[k] || 0) > 0; }).map(function (k) { return invColorMatch[k] || null; });
        var allSame = vals.length > 0 && vals.every(function (v) { return v === vals[0]; });
        var current = allSame ? vals[0] : prodColorMatch;
        var none = !current, cons = current === 'consistency', col = current === 'color';
        $('#pcmNone').toggleClass('active-none', none);
        $('#pcmConsistency').toggleClass('active-consistency', cons);
        $('#pcmColor').toggleClass('active-color', col);
        $('#pcmRadioNone').attr('class', 'prod-cm-radio' + (none ? ' checked' : ''));
        $('#pcmRadioConsistency').attr('class', 'prod-cm-radio' + (cons ? ' checked-green' : ''));
        $('#pcmRadioColor').attr('class', 'prod-cm-radio' + (col ? ' checked-amber' : ''));
    }

    // ---- drawer event handlers (delegated) ----
    // −/+ steppers: update state, sync the input value, and refresh totals/fee.
    $(document).on('click', '#sizeCardsWrap [data-qty-step]', function () {
        var parts = $(this).data('qty-step').toString().split(':');
        var sizeId = parts[0], delta = parseInt(parts[1]);
        var nv = Math.max(0, (invQtys[sizeId] || 0) + delta);
        if (nv > 0) invQtys[sizeId] = nv; else { delete invQtys[sizeId]; delete invColorMatch[sizeId]; }
        var row = $(this).closest('.inv-row');
        row.find('.iv-qty-input').val(nv);
        row.toggleClass('has-qty', nv > 0);
        row.find('.iv-cm-select').prop('disabled', nv === 0).val(invColorMatch[sizeId] || '');
        row.find('.iv-cm-fee').text(rowFeeHtml(sizeId));
        var g = CATALOG.filter(function (x) { return x.groupId === activeGroupId; })[0];
        if (g) { updateInvTotals(g); renderProdCmUI(); }
    });
    // Typing qty: update state + totals in place (no rebuild → focus preserved).
    $(document).on('input', '#sizeCardsWrap [data-qty-input]', function () {
        var sizeId = $(this).data('qty-input').toString();
        var qty = parseInt($(this).val()) || 0;
        var row = $(this).closest('.inv-row');
        if (qty > 0) invQtys[sizeId] = qty; else { delete invQtys[sizeId]; delete invColorMatch[sizeId]; }
        row.toggleClass('has-qty', qty > 0);
        row.find('.iv-cm-select').prop('disabled', qty === 0).val(invColorMatch[sizeId] || '');
        row.find('.iv-cm-fee').text(rowFeeHtml(sizeId));
        var g = CATALOG.filter(function (x) { return x.groupId === activeGroupId; })[0];
        if (g) { updateInvTotals(g); renderProdCmUI(); }
    });
    // CM dropdown change — update state, refresh that row's fee + totals.
    $(document).on('change', '#sizeCardsWrap [data-cm]', function () {
        var sizeId = $(this).data('cm').toString();
        var val = $(this).val();
        if (!val) delete invColorMatch[sizeId]; else invColorMatch[sizeId] = val;
        prodColorMatch = null;
        $(this).closest('.inv-row').find('.iv-cm-fee').text(rowFeeHtml(sizeId));
        var g = CATALOG.filter(function (x) { return x.groupId === activeGroupId; })[0];
        if (g) { updateInvTotals(g); renderProdCmUI(); }
    });
    $(document).on('click', '#prodCmSection [data-prod-cm]', function () {
        var v = $(this).data('prod-cm').toString();
        setProdColorMatch(v === 'none' ? null : v);
    });

    function addInvToCart() {
        var g = CATALOG.filter(function (x) { return x.groupId === activeGroupId; })[0];
        if (!g) return;
        // Replace this product's lines with the drawer's current per-size state.
        state.cart = state.cart.filter(function (c) { return c.groupId !== g.groupId; });
        g.sizes.forEach(function (szObj) {
            var qty = invQtys[szObj.sizeId] || 0;
            if (qty <= 0) return;
            var cm = invColorMatch[szObj.sizeId] || null;
            state.cart.push({
                id: g.groupId + '-' + szObj.sizeId, groupId: g.groupId,
                typeId: g.typeId, shapeId: g.shapeId, sizeId: szObj.sizeId,
                baseStoneName: g.baseStoneName, shadeName: g.shadeName, shapeName: g.shapeName,
                size: szObj.size, weight: szObj.weight, price: szObj.pricePerStone, qty: qty, img: g.img,
                matchConsistency: cm === 'consistency', matchColor: cm === 'color'
            });
        });
        closeInvPanel();
        renderCatalog();
        renderSidebar();
        if (currentStep === 3) renderConfirm();
    }

    // ---- SIDEBAR TRAY (one card per product; per-size color matching) ----
    function lineFee(items) {
        return items.reduce(function (s, c) { return s + (c.matchColor ? computeMatchFee(c.qty) : 0); }, 0);
    }
    function cartTotal() {
        return state.cart.reduce(function (s, c) { return s + c.price * c.qty + (c.matchColor ? computeMatchFee(c.qty) : 0); }, 0);
    }
    function groupCart() {
        var groups = {};
        state.cart.forEach(function (c) { (groups[c.groupId] = groups[c.groupId] || []).push(c); });
        return groups;
    }

    // Per-row Additional cell: Match Color -> fee (or "Call for quote"); Match
    // Consistency -> label only (no $, it's free); none -> dash.
    function addlCell(sz) {
        if (sz.matchColor && sz.qty > 15) return '<span class="addl-amt">Call for quote</span><span class="addl-lbl">Match Color</span>';
        if (sz.matchColor && computeMatchFee(sz.qty) > 0) return '<span class="addl-amt">' + fmt(computeMatchFee(sz.qty)) + '</span><span class="addl-lbl">Match Color</span>';
        if (sz.matchColor) return '<span class="addl-lbl">Match Color</span>';
        if (sz.matchConsistency) return '<span class="addl-lbl">Match Consistency</span>';
        return '&mdash;';
    }

    function renderGroupCard(gid, items, opts) {
        var g = items[0];
        var rows = items.slice().sort(function (a, b) { return (a.weight || 0) - (b.weight || 0); }).map(function (sz) {
            var qtyControls = opts.editable
                ? '<div class="os-size-qty"><button class="os-qty-btn" data-qty-change="' + sz.id + ':-1">&minus;</button>' +
                '<span class="os-qty-num">' + sz.qty + '</span>' +
                '<button class="os-qty-btn" data-qty-change="' + sz.id + ':1">+</button></div>'
                : sz.qty;
            // Weight hidden in the tray (client); shown on Confirm as an "approx.
            // wt. per stone" sub-line so the customer sees carat weight at review.
            var wtLine = opts.showWeight
                ? '<div class="ct-sub">approx. wt. per stone: ' + (sz.weight || 0).toFixed(2) + ' ct</div>'
                : '';
            return '<tr>' +
                '<td><div class="size-lbl">' + sz.size + ' mm</div>' + wtLine + '</td>' +
                '<td>' + fmt(sz.price) + '</td>' +
                '<td>' + addlCell(sz) + '</td>' +
                '<td>' + qtyControls + '</td></tr>';
        }).join('');
        var stonesTotal = items.reduce(function (s, sz) { return s + sz.price * sz.qty; }, 0);
        var groupTotal = stonesTotal + lineFee(items);

        return '<div class="os-item"><div class="os-item-top">' +
            (opts.editViaDrawer ? '<div class="os-item-click" data-edit-group="' + gid + '" title="Click to edit">' : '<div class="os-item-click">') +
            '<div class="os-item-thumb">' + thumbImg(g.img, g.baseStoneName) + '</div>' +
            '<div style="flex:1;min-width:0"><div class="os-item-name">' + g.baseStoneName + (g.shadeName ? ' — ' + g.shadeName : '') + '</div>' +
            '<div class="os-item-sub">' + g.shapeName + '</div></div></div>' +
            '<div class="os-item-actions">' +
            (opts.editViaDrawer ? '<a class="os-edit" href="javascript:;" data-edit-group="' + gid + '">Edit</a>' : '') +
            (opts.removable ? '<button class="os-remove" data-remove-group="' + gid + '" title="Remove">&times;</button>' : '') +
            '</div>' + '</div>' +
            '<table class="os-size-table">' +
            '<thead><tr><td>Size</td><td>Est.</td><td>Notes</td><td style="text-align:right">Qty</td></tr></thead>' +
            '<tbody>' + rows + '</tbody>' +
            '<tfoot><tr><td colspan="3" style="font-size:11px;font-weight:700;color:var(--blue)">Group Total</td>' +
            '<td style="font-size:11px;font-weight:700;color:var(--blue);text-align:right">' + fmt(groupTotal) + '</td></tr></tfoot></table></div>';
    }

    function renderSidebar() {
        var count = state.cart.reduce(function (s, c) { return s + c.qty; }, 0);
        $('#osTrayCount').text(count);
        $('#mobileTrayCount').text(count);
        $('#osProceedBtn').prop('disabled', state.cart.length === 0);
        if (state.cart.length === 0) {
            $('#osEmpty').show(); $('#osItems').html('');
            $('#osSubtotal, #osTotal').text('—'); $('#osTotalItems').text('0');
            $('#osAdditionalRow').hide();
            return;
        }
        $('#osEmpty').hide();
        var groups = groupCart();
        $('#osItems').html(Object.keys(groups).map(function (gid) { return renderGroupCard(gid, groups[gid], { editable: true, removable: true, editViaDrawer: true }); }).join(''));
        $('#osItems [data-qty-change]').on('click', function (e) {
            e.stopPropagation();
            var parts = $(this).data('qty-change').toString().split(':');
            changeSidebarQty(parts[0], parseInt(parts[1]));
        });
        $('#osItems [data-remove-group]').on('click', function (e) {
            e.stopPropagation();
            removeGroup($(this).data('remove-group').toString());
        });
        // Click the product card to reopen the drawer for the whole product,
        // pre-filled with every size + its color-match choice, for editing.
        $('#osItems [data-edit-group]').on('click', function () {
            openInvPanel($(this).data('edit-group').toString());
        });

        var b = additionalChargesBreakdown();
        $('#osTotalItems').text(count + ' stone' + (count !== 1 ? 's' : ''));
        $('#osSubtotal').text(fmt(b.stonesTotal));
        // Total additional charges (color-matching fees) shown as its own line, only
        // when there is one. Consistency is free, so it never adds a charge here.
        if (b.matchingFee > 0) {
            $('#osAdditionalRow').show();
            $('#osAdditional').text(fmt(b.matchingFee));
        } else {
            $('#osAdditionalRow').hide();
        }
        $('#osTotal').text(fmt(cartTotal()));
    }
    function changeSidebarQty(itemId, delta) {
        var item = state.cart.filter(function (c) { return c.id === itemId; })[0];
        if (!item) return;
        item.qty = Math.max(0, item.qty + delta);
        if (item.qty === 0) state.cart = state.cart.filter(function (c) { return c.id !== itemId; });
        renderSidebar(); renderCatalog();
        if (currentStep === 3) renderConfirm();
    }
    function removeGroup(gid) {
        state.cart = state.cart.filter(function (c) { return c.groupId !== gid; });
        renderSidebar(); renderCatalog();
        if (currentStep === 3) renderConfirm();
    }

    // ---- STEP NAV ----
    function showStep(n) {
        currentStep = n;
        [1, 2, 3].forEach(function (i) {
            $('#panel' + i).toggleClass('active', i === n);
            var ws = $('#ws' + i).removeClass('active done');
            if (i === n) ws.addClass('active'); else if (i < n) ws.addClass('done');
        });
        $(root).toggleClass('step-3-active', n === 3);
        var lbls = ['Proceed to Details →', 'Review & Confirm →', 'Confirm Order →'];
        $('#osProceedBtn').text(lbls[n - 1] || lbls[0]);
        $('#mobileStepSelect').val(n);
        if (n === 3) renderConfirm();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    function gotoStep(n) { if (n <= currentStep) showStep(n); }
    // Mobile step dropdown. Going back → jump directly. Going forward → advance
    // one step through the normal flow so validation + order-save still run (a
    // multi-step forward jump just advances one step; pick again to continue).
    // The select re-syncs to the real current step via showStep().
    $(document).on('change', '#mobileStepSelect', function () {
        var target = parseInt($(this).val());
        if (target <= currentStep) gotoStep(target);
        else nextStep(currentStep);
        $(this).val(currentStep);
    });

    function nextStep(from) {
        if (from === 1) {
            if (state.cart.length === 0) { alert('Please add at least one gemstone.'); return; }
            createOrderItems(function () { showStep(2); });
        } else if (from === 2) {
            if (!validateStep2()) return;
            updateOrderExtras(function () { showStep(3); });
        }
    }
    function sidebarProceed() { nextStep(currentStep); }

    // ---- PERSIST CART -> pending order (server recomputes price, never trusts client) ----
    function createOrderItems(onDone) {
        // Plain form-urlencoded POST, NOT JSON — a JSON content-type forces the
        // browser to CORS-preflight (OPTIONS) this cross-domain request, and this
        // app doesn't answer preflights with an Access-Control-Allow-Origin header
        // (every other endpoint here — including SubmitOrder, which this file also
        // calls — avoids that entirely by staying form-encoded). ASP.NET MVC's
        // default model binder still binds `items[i].xxx` fields straight into
        // GemstoneOrderRequest.items on the server, so no C# change was needed.
        var fd = [
            { name: 'customerId', value: parseInt($('#customer_id').val()) || 0 },
            { name: 'customerName', value: $('#shopify_contact_name').val() },
            { name: 'customerEmail', value: $('#shopify_email').val() },
            { name: 'customerNotes', value: $('#customerNotes').val() }
        ];
        state.cart.forEach(function (c, i) {
            fd.push({ name: 'items[' + i + '].typeId', value: c.typeId });
            fd.push({ name: 'items[' + i + '].shapeId', value: c.shapeId });
            fd.push({ name: 'items[' + i + '].sizeId', value: c.sizeId });
            fd.push({ name: 'items[' + i + '].qty', value: c.qty });
            fd.push({ name: 'items[' + i + '].matchConsistency', value: !!c.matchConsistency });
            fd.push({ name: 'items[' + i + '].matchColor', value: !!c.matchColor });
        });
        $.ajax({
            url: Applink + 'GemstoneStore/CreateOrderItems',
            type: 'POST',
            data: $.param(fd),
            dataType: 'json',
            beforeSend: function () { $('#looseGemstoneStoreV2').addClass('show-loader'); }
        }).done(function (res) {
            $('#looseGemstoneStoreV2').removeClass('show-loader');
            if (res && res.order && res.order.order_id) {
                $('#order_id').val(res.order.order_id);
            }
            if (onDone) onDone();
        }).fail(function (e) {
            $('#looseGemstoneStoreV2').removeClass('show-loader');
            console.error('CreateOrderItems failed', e);
            alert('Something went wrong saving your order. Please try again.');
        });
    }

    // PO Number / Request a Catalog are entered on Step 2/3 — persist them once
    // known, right before moving to the Confirm step.
    function updateOrderExtras(onDone) {
        $.ajax({
            url: Applink + 'GemstoneStore/UpdateOrderExtras',
            type: 'POST',
            dataType: 'json',
            data: {
                customerId: parseInt($('#customer_id').val()) || 0,
                poNumber: $('#poNumber').val(),
                requestCatalog: $('#requestCatalogChk').is(':checked'),
                addOnProducts: selectedAddOns().join(', ')
            },
            beforeSend: function () { $('#looseGemstoneStoreV2').addClass('show-loader'); }
        }).always(function () {
            $('#looseGemstoneStoreV2').removeClass('show-loader');
            if (onDone) onDone();
        });
    }

    // ---- STEP 2 ----
    $(document).on('change', '#shipAltAddrChk', function () {
        $('#altAddrFields').toggleClass('hidden', !this.checked);
        $('#altAddrErr').removeClass('show');
    });
    $(document).on('change', '#shippingMethod', function () {
        var isIntl = this.value.indexOf('intl-') === 0;
        $('#intlShipNote').css('display', isIntl ? '' : 'none');
        $('#shippingErr').removeClass('show');
    });

    function validateStep2() {
        var ok = true;
        if (!$('#shippingMethod').val()) { $('#shippingErr').addClass('show'); ok = false; }
        if ($('#shipAltAddrChk').is(':checked')) {
            var required = ['#altName', '#altStreet', '#altCity', '#altState', '#altZip'];
            var filled = required.every(function (sel) { return $(sel).val().trim(); });
            if (!filled) { $('#altAddrErr').addClass('show'); ok = false; }
        }
        return ok;
    }

    function altAddressString() {
        if (!$('#shipAltAddrChk').is(':checked')) return '';
        var parts = [$('#altName').val(), $('#altStreet').val(), $('#altCity').val(), $('#altState').val(), $('#altZip').val(), $('#altPhone').val()].filter(Boolean);
        if ($('#altIsResidence').is(':checked')) parts.push('Residential address');
        return parts.join(', ');
    }

    // ---- STEP 3 ----
    // Additional charges broken out separately from the stones subtotal — total
    // Color Matching fee and total Color Consistency fee (currently always free,
    // but computed rather than hardcoded so it stays correct if that ever changes).
    function additionalChargesBreakdown() {
        // Per-size now — each cart line carries its own match choice and qty.
        var stonesTotal = 0, matchingFee = 0, matchingQty = 0, consistencyQty = 0;
        state.cart.forEach(function (c) {
            stonesTotal += c.price * c.qty;
            if (c.matchColor) { matchingQty += c.qty; matchingFee += computeMatchFee(c.qty); }
            else if (c.matchConsistency) { consistencyQty += c.qty; }
        });
        return { stonesTotal: stonesTotal, matchingFee: matchingFee, matchingQty: matchingQty, consistencyQty: consistencyQty };
    }

    function renderConfirm() {
        var il = $('#confirmItemsList');
        if (state.cart.length === 0) { il.html('<p style="color:var(--gray);font-size:12px;font-style:italic;">No items.</p>'); }
        else {
            var groups = groupCart();
            // Same grouped tray-card layout as the sidebar, but read-only — qty/removal
            // controls are disabled here because the order's line items were already
            // persisted server-side back at Step 1 -> 2 (CreateOrderItems); adjusting
            // qty on this page only mutated the client-side cart display and never
            // re-synced the saved rows, so what got emailed/saved could silently
            // diverge from what the customer saw here. Changes now only happen via
            // "Edit ->", which sends them back to Step 1 where edits go through the
            // normal add/update flow.
            il.html(Object.keys(groups).map(function (gid) { return renderGroupCard(gid, groups[gid], { editable: false, removable: false, showWeight: true }); }).join(''));
        }
        var sm = document.getElementById('shippingMethod');
        $('#conf-po').text($('#poNumber').val().trim() || '—');
        // #conf-shipto is server-rendered with the account's default address on
        // page load; only overwrite it here if the customer checked "Ship to
        // Alternate Address" on Step 2 — otherwise leave the default text as-is.
        var altAddr = altAddressString();
        if (altAddr) $('#conf-shipto').text(altAddr);
        else if ($('#conf-shipto').data('default-set') !== true) {
            $('#conf-shipto').data('default-text', $('#conf-shipto').text()).data('default-set', true);
        } else {
            $('#conf-shipto').text($('#conf-shipto').data('default-text'));
        }
        $('#conf-shipping').text(sm.options[sm.selectedIndex] ? sm.options[sm.selectedIndex].text : '—');
        $('#conf-notes').text($('#customerNotes').val().trim() || '—');
        var t = cartTotal();
        var cnt = state.cart.reduce(function (s, c) { return s + c.qty; }, 0);
        $('#conf-count').text(cnt + ' stone' + (cnt !== 1 ? 's' : ''));
        var b = additionalChargesBreakdown();
        $('#conf-subtotal').text(fmt(b.stonesTotal));
        $('#otp-matching-row').toggleClass('hidden', b.matchingQty === 0);
        $('#conf-matching-fee').text(fmt(b.matchingFee));
        $('#otp-consistency-row').toggleClass('hidden', b.consistencyQty === 0);
        $('#conf-consistency-fee').text('Free');
        $('#conf-total').text(fmt(t));
        // Flag-only add-ons — list the checked ones in the total widget (no price,
        // total is unchanged); the names also go to the order/email on submit.
        var addOns = selectedAddOns();
        $('#otp-addon-row').toggleClass('hidden', addOns.length === 0);
        $('#conf-addon-list').text(addOns.join(', '));
    }

    // Optional Step 3 add-on products (from the section's chosen collection).
    // Checkbox = fixed qty 1, unchecking removes it. Flag-only, not priced.
    function selectedAddOns() {
        return $('#addOnList .addon-chk:checked').map(function () {
            return String($(this).data('addon-title'));
        }).get();
    }
    $(document).on('change', '.addon-chk', function () { if (currentStep === 3) renderConfirm(); });
    // Confirm & Submit is gated on the authorization checkbox.
    // Keep the inline confirm checkbox/submit (desktop) and the sticky bar's
    // checkbox/submit (mobile) in lock-step, so either one gates both submits.
    $(document).on('change', '#confAuthorize, #confAuthorizeSticky', function () {
        var checked = this.checked;
        $('#confAuthorize, #confAuthorizeSticky').prop('checked', checked);
        $('#btnSubmitOrder, #btnSubmitOrderSticky').prop('disabled', !checked);
    });
    // Add-on title/chevron toggles its description accordion (PDP style, no popup).
    // The checkbox is a separate control, so expanding doesn't select the add-on.
    $(document).on('click', '[data-addon-toggle]', function () {
        var item = $(this).closest('.addon-item');
        var open = item.find('.addon-desc').toggleClass('hidden').hasClass('hidden') === false;
        item.toggleClass('open', open);
        item.find('[data-addon-toggle]').attr('aria-expanded', open ? 'true' : 'false');
    });

    // ---- FINAL SUBMIT (shipping-preferences popup removed per feedback doc —
    // alternate address now lives on Step 2, submit goes straight through) ----
    function submitOrder() {
        // Authorization checkbox must be ticked (belt-and-suspenders — the button
        // is also disabled until then).
        if (!$('#confAuthorize').is(':checked')) {
            alert('Please confirm your authorization before submitting the order.');
            return;
        }
        // updateOrderExtras() already ran once on the Step 2 -> 3 transition, but
        // "Request a Catalog" lives ON Step 3 — at that point the customer hasn't
        // seen the checkbox yet, so that first save always sent requestCatalog as
        // unchecked. Re-save here, right before final submit, so whatever they
        // actually checked on Step 3 is what gets persisted and emailed.
        updateOrderExtras(function () { doSubmitOrder(); });
    }
    function doSubmitOrder() {
        var fd = $('#customer_order_v2').serializeArray();
        var isAlt = $('#shipAltAddrChk').is(':checked');
        var extra = {
            customer_notes: $('#customerNotes').val(),
            shipping_method: $('#shippingMethod').val(),
            shipping_account: isAlt ? 'No' : 'Yes',
            ship_alternate_address: altAddressString(),
            shipping_notes: '',
            schedule_order: '',
            // Preferred Method of Contact was removed from the UI per the feedback
            // doc, but SubmitOrder still requires these keys to be present —
            // fc["contact_method"].ToString() throws a NullReferenceException if the
            // key is entirely missing from the POST body (existing bug, not
            // introduced here) — send them empty rather than omit them.
            contact_method: '',
            contact_phone: '',
            ship_partial: '',
            contact_discuss: ''
        };
        Object.keys(extra).forEach(function (k) { fd.push({ name: k, value: extra[k] }); });

        $.ajax({
            url: Applink + 'CustomerOrder/SubmitOrder',
            type: 'POST',
            dataType: 'json',
            data: $.param(fd),
            beforeSend: function () { $('#looseGemstoneStoreV2').addClass('show-loader'); }
        }).done(function (data) {
            $('#looseGemstoneStoreV2').removeClass('show-loader');
            // SubmitOrder returns a 200 with {error:true, message:...} in some
            // defensive paths (belt-and-suspenders alongside the non-2xx status it
            // normally sends on failure) — check both so neither slips through as
            // a false "success".
            if (data && data.error) {
                alert(data.message || 'Something went wrong submitting your order. Please try again.');
                return;
            }
            [1, 2, 3].forEach(function (i) {
                $('#panel' + i).removeClass('active');
                $('#ws' + i).removeClass('active').addClass('done');
            });
            // The "Start Another Order" button on the success screen does a full
            // location.reload(), which resets everything — but that shouldn't be
            // the ONLY thing standing between a submitted order and a stale cart.
            // Without this, state.cart still held every already-submitted line, so
            // if the customer got back to Step 1 any other way (browser back, etc.)
            // and added more items, the next order was created fresh (CreateOrderItems
            // only reuses a "pending" order, and the prior one was already
            // "confirmed") but populated with the OLD items plus the new ones —
            // looking like a merge, when it was really a stale client-side cart.
            state.cart = [];
            $('#order_id').val('');
            renderSidebar();
            $('#successPage').addClass('show');
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }).fail(function (e) {
            $('#looseGemstoneStoreV2').removeClass('show-loader');
            console.error('SubmitOrder failed', e);
            var msg = (e && e.responseJSON && e.responseJSON.message) || 'Something went wrong submitting your order. Please try again.';
            alert(msg);
        });
    }

    // Console audit — run LGSv2.auditImages() to list catalog images that have
    // NEITHER a working .png nor .jpg on the server (so you can see what's still
    // missing after uploading). Prints a table of missing image names.
    function auditImages() {
        var seen = {}, names = [];
        CATALOG.forEach(function (g) { if (g.img && !seen[g.img]) { seen[g.img] = 1; names.push(g.img); } });
        var pending = names.length, ok = 0, missing = [];
        if (!pending) { console.log('[audit] no catalog images to check'); return; }
        console.log('[audit] checking ' + pending + ' images (png + jpg)…');
        names.forEach(function (name) {
            var urls = imgUrls(name, false), i = 0, im = new Image();
            im.onload = function () { ok++; if (--pending === 0) finish(); };
            im.onerror = function () { i++; if (i < urls.length) { im.src = urls[i]; } else { missing.push(name); if (--pending === 0) finish(); } };
            im.src = urls[0];
        });
        function finish() {
            console.log('[audit] OK ' + ok + ' / ' + names.length + '  |  MISSING ' + missing.length);
            if (missing.length) console.table(missing.map(function (m) { return { missing_image: m }; }));
            else console.log('[audit] all catalog images resolved ✔');
        }
    }

    // Console audit — run LGSv2.auditRoundfill() to list catalog images whose
    // "roundfill" twin (UploadedFiles/roundfill/<name>.jpg|png) is MISSING. Those
    // fall back to the big product photo on the round Options swatches / filter
    // icons (e.g. a small cabochon floating on white instead of filling the circle,
    // like Opal "Black & Red"). Prints a table of the images that still need a
    // roundfill twin uploaded.
    function auditRoundfill() {
        var seen = {}, names = [];
        CATALOG.forEach(function (g) { if (g.img && !seen[g.img]) { seen[g.img] = 1; names.push(g.img); } });
        var pending = names.length, ok = 0, missing = [];
        if (!pending) { console.log('[roundfill] no catalog images to check'); return; }
        console.log('[roundfill] checking ' + pending + ' roundfill twins…');
        names.forEach(function (name) {
            var base = String(name).replace(/\.(jpe?g|png|gif)$/i, '');
            var urls = [IMG_BASE + 'roundfill/' + base + '.jpg', IMG_BASE + 'roundfill/' + base + '.png'];
            var i = 0, im = new Image();
            im.onload = function () { ok++; if (--pending === 0) finish(); };
            im.onerror = function () { i++; if (i < urls.length) { im.src = urls[i]; } else { missing.push(name); if (--pending === 0) finish(); } };
            im.src = urls[0];
        });
        function finish() {
            console.log('[roundfill] OK ' + ok + ' / ' + names.length + '  |  MISSING ' + missing.length);
            if (missing.length) console.table(missing.map(function (m) {
                return { image: m, needs: 'UploadedFiles/roundfill/' + String(m).replace(/\.(jpe?g|png|gif)$/i, '') + '.jpg' };
            }));
            else console.log('[roundfill] all roundfill twins present ✔');
        }
    }

    // ---- expose namespace used by inline onclick= handlers in the section markup ----
    function openPriceList() {
        $('#priceListModal').addClass('open');
        $('body').css('overflow', 'hidden');
    }
    function closePriceList() {
        $('#priceListModal').removeClass('open');
        $('body').css('overflow', '');
    }

    window.LGSv2 = {
        gotoStep: gotoStep, nextStep: nextStep, sidebarProceed: sidebarProceed,
        clearGemType: clearGemType, clearShape: clearShape, setView: setView,
        closeInvPanel: closeInvPanel, addInvToCart: addInvToCart,
        submitOrder: submitOrder, toggleFilters: toggleFilters, toggleTray: toggleTray,
        openPriceList: openPriceList, closePriceList: closePriceList,
        auditImages: auditImages, auditRoundfill: auditRoundfill,
        // Console helper: LGSv2.clearCache() wipes this browser's cached catalog and
        // reloads fresh from the server (pair with /GemstoneStore/ClearCache).
        clearCache: function () { clearCatalogCache(); loadCatalog(); }
    };

    loadCatalog();
})();